import { getLeadManagementGuidanceStatuses } from '@/http'

export default {
  data() {
    return {
      guidancePollTimer: null,
      guidanceRefreshPending: false
    }
  },
  mounted() {
    this.guidancePollTimer = setInterval(this.refreshGuidanceStatuses, 30000)
    if (typeof document !== 'undefined') {
      document.addEventListener('visibilitychange', this.onGuidanceVisibilityChange)
    }
  },
  beforeDestroy() {
    clearInterval(this.guidancePollTimer)
    if (typeof document !== 'undefined') {
      document.removeEventListener('visibilitychange', this.onGuidanceVisibilityChange)
    }
  },
  methods: {
    onGuidanceVisibilityChange() {
      if (!document.hidden) this.refreshGuidanceStatuses()
    },
    async refreshGuidanceStatuses() {
      if (this.guidanceRefreshPending || (typeof document !== 'undefined' && document.hidden)) return
      const rows = this.guidanceRows().filter(row => Boolean(row.management_guidance_status))
      const ids = [...new Set(rows.map(row => Number(row.id)).filter(id => Number.isInteger(id) && id > 0))]
      if (!ids.length) return
      this.guidanceRefreshPending = true
      try {
        for (let index = 0; index < ids.length; index += 200) {
          const { data } = await getLeadManagementGuidanceStatuses(ids.slice(index, index + 200))
          const statuses = new Map((data.results || []).map(item => [item.id, item]))
          rows.forEach(row => {
            const id = Number(row.id)
            if (!statuses.has(id)) return
            const item = statuses.get(id)
            this.$set(row, 'management_guidance_status', item.status)
            if (typeof item.comment === 'string') this.$set(row, 'management_guidance_comment', item.comment)
          })
        }
      } catch (_) {
        // Keep the last displayed state until the next poll or page refresh.
      } finally {
        this.guidanceRefreshPending = false
      }
    }
  }
}
